import {
  GET_PAYMENT_REQUEST_DATA,
  GET_PAYMENT_REQUEST_DATA_SUCCESS,
  GET_PAYMENT_REQUEST_DATA_FAILURE,
  GET_PAYMENT_COMPLETE_DATA,
  GET_PAYMENT_COMPLETE_DATA_SUCCESS,
  GET_PAYMENT_COMPLETE_DATA_FAILURE,
} from "./actionType";

//GET_PAYMENT_REQUEST_DATA
export const getPaymentRequestData = (payload) => {
  return {
    type: GET_PAYMENT_REQUEST_DATA,
    payload,
  };
};
//GET_PAYMENT_REQUEST_DATA_SUCCESS
export const getPaymentRequestDataSuccess = (payload) => {
  return {
    type: GET_PAYMENT_REQUEST_DATA_SUCCESS,
    payload,
  };
};
//GET_PAYMENT_REQUEST_DATA_FAILURE
export const getPaymentRequestDataFailure = (payload) => {
  return {
    type: GET_PAYMENT_REQUEST_DATA_FAILURE,
    payload,
  };
};
//GET_PAYMENT_COMPLETE_DATA
export const getPaymentCompleteData = (payload) => {
  return {
    type: GET_PAYMENT_COMPLETE_DATA,
    payload,
  };
};
//GET_PAYMENT_COMPLETE_DATA_SUCCESS
export const getPaymentCompleteDataSuccess = (payload) => {
  return {
    type: GET_PAYMENT_COMPLETE_DATA_SUCCESS,
    payload,
  };
};
//GET_PAYMENT_COMPLETE_DATA_FAILURE
export const getPaymentCompleteDataFailure = (payload) => {
  return {
    type: GET_PAYMENT_COMPLETE_DATA_FAILURE,
    payload,
  };
};
